module.exports = __webpack_public_path__ + "img/logo_consorcio_branco.b4a2b3c0.png";